import { Schema } from 'effect';

/**
 * Plain object representation of DateTime that can be serialized
 * across Server/Client Component boundary in Next.js.
 *
 * The ISO string includes timezone info:
 * - UTC: `2024-12-10T14:30:00.000Z`
 * - Offset: `2024-12-10T14:30:00.000+01:00`
 * - Named: `2024-12-10T14:30:00.000+01:00[Europe/Prague]`
 */
export const DateTimeSerializable = Schema.TaggedStruct('DateTime', {
  value: Schema.String,
});

export type DateTimeSerializable = Schema.Schema.Type<typeof DateTimeSerializable>;
